<template>
  <a :href="homeUrl">
    <LogoRDK v-if="theme === THEMES.RDK" class="lg:h-[58px] lg:w-[285px]" />
    <Logo v-else-if="lang === 'sv'" :class="logoClass" />
    <LogoEn v-else-if="lang === 'en'" :class="logoClass" />
    <LogoUk v-else-if="lang === 'uk'" :class="logoClass" />
  </a>
</template>

<script setup lang="ts">
import { Logo, LogoEn, LogoUk, THEMES, LogoRDK } from 'refresh-ui'
import { computed } from 'vue'

const config = useRuntimeConfig()

const props = withDefaults(
  defineProps<{
    theme?: THEMES
    homeUrl?: string
    logoClass?: string
  }>(),
  {
    theme: THEMES.DEFAULT,
    homeUrl: '',
    logoClass: 'h-[38px] w-[95px] lg:h-auto lg:w-[100px]',
  },
)

const homeUrl = computed(() => props.homeUrl || config.public.SITE_PARENT || '/')
const lang = config.public.SITE_LANG || 'sv'
</script>
